module.exports = __webpack_public_path__ + "img/anniu.94453731.png";